import TokenService from '@/helpers/token';
import {userPositions} from "@/helpers/constants";

export function getContactAttribute() {
  const resultOrg = [
    {
      name: 'createdAt',
      title: 'Thời gian',
      value: true,
      sticky: true,
      width: '90px',
    },
    {
      name: 'transactionNumber',
      title: 'Mã giao dịch',
      value: true,
      textAlign: 'center',
    },
    {
      name: 'order.code',
      title: 'Mã đơn hàng',
      value: true,
      alwayShow: true,
    },
    {
      name: 'paymentType',
      title: 'Hình thức',
      value: true,
      alwayShow: true,
      width: '70px',
    },
    {
      name: 'order.userCode',
      title: 'Mã khách hàng',
      value: true,
      alwayShow: true,
    },
    {
      name: 'addition_info',
      title: 'Gói sản phẩm',
      value: true,
      alwayShow: true,
    },{
      name: 'amount',
      title: 'Giá trị',
      value: true,
      alwayShow: true,
    },
    {
      name: 'status',
      title: 'Trạng thái',
      value: true,
      alwayShow: true,
    },
  ];

  let storedData = localStorage.getItem('displayColumnsInModuleTemplate');
  let rowAttributesNotIn = [];
  if(TokenService.getPosition() === userPositions.TELESALES) {
    rowAttributesNotIn = ['contactSources'];
  }
  if(TokenService.getPosition() === userPositions.STAFF) {
    rowAttributesNotIn.push('code');
  }
  if(storedData) {
    storedData = JSON.parse(storedData);
    let storedDataReturn = [];
    if(storedData && storedData.length){
      let isExist = {
        numberOfCall: false
      };
      for(let j = 0; j < resultOrg.length; j++){
        let item = resultOrg[j];
        for(let i = 0; i < storedData.length; i++){
          if(storedData[i].name == item.name){
            item.value = storedData[i].value;
          }
        }
        storedDataReturn.push(item);
      }
    }
    storedDataReturn = storedDataReturn.filter(item => !rowAttributesNotIn.includes(item.name));
    return storedDataReturn;
  }
  let resultOrgClone = resultOrg.filter(item => !rowAttributesNotIn.includes(item.name));
  return resultOrgClone;
  // return resultOrg;
}

export const configCardFilterForm = [
  {
    type: 'common-range-picker',
    clearable: true,
    aLight: 'right',
    label: 'Thời gian',
    vModelKey: 'timeRange',
  },
  {
    type: 'v-autocomplete',
    itemsKey: 'paymentProviders',
    vModelKey: 'paymentProvider',
    itemText: 'name',
    itemValue: 'value',
    placeholder: 'Cổng giao dịch',
    clearable: true,
    multiple: false,
    hideDetails: true,
  },
  {
    type: 'v-autocomplete',
    itemsKey: 'paymentTypes',
    vModelKey: 'paymentTypeId',
    itemText: 'name',
    itemValue: 'value',
    placeholder: 'Hình thức',
    clearable: true,
    multiple: false,
    hideDetails: true,
  },
];

export const genFilterForm = () => {
  let filterForm = {
    closeMenu: false,
    keyword: '',
  };
  let mapListOptionsFilterForm = {};
  let mapKeyAndIsMultiple = {};
  let mapKeyAndDataType = {};
  configCardFilterForm.forEach((el) =>{
    mapKeyAndDataType[el.vModelKey] = el.dataType;
    if (el.itemsKey){
      mapListOptionsFilterForm[el.itemsKey] = [];
    }
    if (el.type === 'v-auto-autocomplete' || el.type === 'common-range-picker'){
      filterForm[el.vModelKey] = [];
      mapKeyAndIsMultiple[el.vModelKey] = true;
    }
    if (el.type !== 'v-auto-autocomplete' && el.type !== 'common-range-picker') {
      if (el.multiple) {
        filterForm[el.vModelKey] = [];
        mapKeyAndIsMultiple[el.vModelKey] = true;
      }
      if (!el.multiple) {
        filterForm[el.vModelKey] = '';
      }
    }
  });
  return {filterForm, mapListOptionsFilterForm, mapKeyAndIsMultiple, mapKeyAndDataType};
};
